import { FontWeight, Heading, HeadingVariant, LiliTextInput } from '@lili/lili-frontend-common';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { OnboardingFormFields } from '@Types/index';
import { ControllerWrapper } from '@Hooks/index';
import { Icon, Icons } from '@Components/icon/Icon';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { StepFooter } from './shared/StepFooter';
import { useResetPasswordRequestLogic } from './hooks/useResetPasswordRequestLogic';
import { MobileBackButton } from './shared/MobileBackButton';

export const ResetPasswordRequest = () => {
  const { formMethods, handleSubmit, handleBack } = useResetPasswordRequestLogic();
  const { isMobile } = useResizeListener();
  const { t } = useTranslation();

  return (
    <div className='recovery-page-container'>
      <MobileBackButton isFirstStep />
      <div className='flex flex-col pt-[56px] md:pt-[0px] w-full md:w-[520px] px-[24px] md:px-[42px] items-center'>
        <Icon icon={Icons.Shield} className='w-[90px] mb-[40px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H3}
          fontWeight={FontWeight.MEDIUM}
          className='recovery-page-header'>
          {t('recovery.resetPasswordRequest.title')}
        </Heading>
        <Heading.H10
          fontWeight={FontWeight.REGULAR}
          className='text-text-main-secondary w-[350px] text-center mb-[24px]'>
          {t('recovery.resetPasswordRequest.subtitle')}
        </Heading.H10>
        <div className='w-full'>
          <FormProvider {...formMethods}>
            <ControllerWrapper name={OnboardingFormFields.EMAIL} control={formMethods.control}>
              {({ value, onChange, onBlur, error }) => (
                <LiliTextInput
                  showClear
                  tabIndex={0}
                  onChange={onChange}
                  id={OnboardingFormFields.EMAIL}
                  title={t('recovery.resetPasswordRequest.emailInput')}
                  onBlur={onBlur}
                  value={value}
                  errorMessage={error?.message}
                  isPublic={false}
                />
              )}
            </ControllerWrapper>
          </FormProvider>
        </div>
        <StepFooter
          id='reset-password-request'
          title={t('recovery.shared.footerContinue')}
          onClick={handleSubmit}
          onBackClick={handleBack}
          disabled={!formMethods.formState.isValid}
        />
      </div>
    </div>
  );
};
